<template>
  <div class="verifyEmail d-flex justify-content-center align-items-center min-vh-100">
    <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
      <Loading />
    </div>
    <div v-else-if="error" class="min-vh-100 d-flex align-items-center justify-content-center">
      <div>
       <h1 class="text-white font-weight-bold">
            Verification Failed
        </h1>
        <p class="text-white font-weight-bold">
           {{ error }}
        </p>
        <p class="text-2xl text-white font-weight-bold">
        </p>
      </div>
    </div>
    <div v-else>
      <div>
        <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
          Please choose the corresponding account to sign in with: {{this.correspondingEmail}}
        </b-alert>
          <h1 class="text-white font-weight-bold">
            Verify your email address
          </h1>
          <p class="text-white">
            Please click the button below to select your authenticated email account
            to activate
          </p>
          <!-- <button class="mx-auto mb-5 px-5 py-3" @click="googleSignIn">
            Sign In with Google
          </button> -->
          <b-button
            class="firebaseui-idp-button firebaseui-idp-google my-4"
            @click="googleSignIn"
            pill variant="light">
            <span class="firebaseui-idp-icon-wrapper">
              <img class="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"></span>
            <span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with Google</span>
            <span class="firebaseui-idp-text firebaseui-idp-text-short">Google</span>
          </b-button>
      </div>
      <div id="firebaseui-auth-container"></div>
    </div>
  </div>
</template>

<script>
// import GoogleLogin from 'vue-google-login';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';
import { emailconfirmation } from '../api/admin';
import Loading from '../components/Loading.vue';
import { verifyUser } from '../api/user';

export default {
  name: 'verifyEmail',
  data() {
    return {
      error: false,
      invalid: false,
      loading: true,
      isInit: false,
      isSignIn: false,
      correspondingEmail: '',
      token: '',
    };
  },
  methods: {
    onSuccess(googleUser) {
      console.log(googleUser);
      console.log(googleUser.getBasicProfile());
    },
    onFailure(error) {
      console.log(error);
    },
    googleSignIn() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          if (this.correspondingEmail.toLowerCase() !== result.user.email.toLowerCase()) {
            this.invalid = true;
            return;
          }
          const data = { data: { name: result.user.displayName, email: result.user.email } };
          verifyUser(data).then((resp) => {
            this.$store.commit('authenticate', { jwt: resp.data });
            this.$router.push('/dash');
          }).catch((err) => {
            console.log(err);
            this.$store.commit('deAuthenticate');
            this.invalid = true;
          });
          // result.user.getIdToken().then((token) => {
          //   console.log(token);
          // });
          // firebase.auth().currentUser.getIdToken(true)
          //   .then((token) => console.log(token));
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.token = this.$route.query.token === undefined ? '' : this.$route.query.token;
    emailconfirmation(this.token).then((res) => {
      console.log(res);
      this.loading = false;
      this.correspondingEmail = res.data.result;
    }).catch((err) => {
      console.log(err);
      this.error = err.response.data.error;
      this.loading = false;
    });
    // let ui = firebaseui.auth.AuthUI.getInstance();
    // if (!ui) {
    //   ui = new firebaseui.auth.AuthUI(firebase.auth());
    // }
    // const uiConfig = {
    //   signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
    //   signInFlow: 'popup',
    //   callbacks: {
    //     signInSuccessWithAuthResult: (authResult) => {
    //       const data = {
    //         data: { name: authResult.user.displayName, email: authResult.user.email },
    //       };
    //       verifyUser(data).then((resp) => {
    //         this.$store.commit('authenticate', { jwt: resp.data });
    //         this.$router.push('/dash');
    //       }).catch((err) => {
    //         console.log(err);
    //         this.$store.commit('deAuthenticate');
    //         this.invalid = true;
    //         ui.start('#firebaseui-auth-container', uiConfig);
    //       });
    //       return false;
    //     },
    //   },
    // };
    // ui.start('#firebaseui-auth-container', uiConfig);
  },
  components: {
    Loading,
  },
};
</script>

<style scoped lang="scss">
.verifyEmail {
  background: radial-gradient(ellipse at top, var(--accent-color), var(--primary-color)),
  radial-gradient(ellipse at bottom, var(--hover-color), var(--secondary-color));
}
</style>
